import { formatStatus } from '@/lib/utils'

export type ActorDirectoryEntry = {
  user_id: string
  email: string
  name?: string | null
}

/** Automation actors store a machine identifier in `created_by` / `resolved_by`. */
const AUTOMATION_ACTOR_LABELS: Record<string, string> = {
  ai: 'AI agent',
  'ai-agent': 'AI agent',
  ai_outbound_review: 'AI agent',
  system: 'System',
  mail_system: 'Mail system',
  delivery_site_verification: 'Delivery site check',
  book_shipping: 'Shipping automation',
  send_post_booking_email: 'Shipping automation',
  'order-simulation': 'Order simulation',
}

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * Turn a stored actor value (staff user id, email, name, or automation id) into
 * the name a person recognizes. Never returns a raw user id.
 */
export function formatActorName(
  value: string | null | undefined,
  directory: readonly ActorDirectoryEntry[] | undefined,
): string | null {
  const actor = value?.trim()
  if (!actor) return null
  const key = actor.toLowerCase()
  const person = directory?.find(
    (entry) => entry.user_id.toLowerCase() === key || entry.email.toLowerCase() === key,
  )
  if (person) return person.name?.trim() || person.email
  const automation = AUTOMATION_ACTOR_LABELS[key]
  if (automation) return automation
  if (UUID_PATTERN.test(actor)) return 'Staff member'
  if (actor.includes('@') || actor.includes(' ')) return actor
  return formatStatus(actor)
}
